<avd-code-example-header
    [packageName]="packageName"
    [getStartedLink]="getStartedLink"
    [storybookLink]="storybookLink"
    [repoLink]="repoLink"
></avd-code-example-header>

@for (example of examples; track example.variant) {
    <avd-code-example
        [label]="example.label"
        [description]="example.description"
        [htmlSnippet]="example.htmlSnippet"
    >
        <uilab-mat-form-field [appearance]="example.appearance">
            <uilab-mat-label>Label</uilab-mat-label>
            <uilab-mat-select placeholder="Select an option">
                @for (option of options; track option) {
                    <uilab-mat-option [value]="option">{{
                        option
                    }}</uilab-mat-option>
                }
            </uilab-mat-select>
        </uilab-mat-form-field>
    </avd-code-example>
}
